// Daily step ranges keyed by day relative to surgery (day 0 = surgery date,
// negative = pre-op, positive = post-op).
//
// 🔴 GENERATED -- DO NOT HAND-EDIT. Source of record:
//   docs/reference/tracpatch/steps_reference.csv   (Low / High columns)
//   node docs/reference/tracpatch/generate-range-tables.js
//
// Low and High are Mean +/- 1 standard deviation over the reference cohort, so
// the band DESCRIBES where roughly the middle 68% of that cohort fell. It is
// not a clinical prescription. Adopted 2026-09-28 on the clinic's instruction,
// replacing a narrower hand-authored table whose source nobody could identify.
//
// Resolution rule: a day earlier than the first row uses the -10 range; a day
// later than the last uses the 60 range.
//
// ⚠️ Mirrored by hand in physio_app_web/business/step_goals.js, which derives
// the PATIENT's daily goal from the same numbers. Nothing enforces that the two
// agree -- regenerate BOTH or the clinician's band and the patient's goal drift
// apart. Serving them per clinic is issue #12.

export const STEP_RANGE_BY_DAY = {
  '-10':  { min: 1731, max: 9378, goal: 5555 },
  '-9':   { min: 1672, max: 8541, goal: 5107 },
  '-8':   { min: 2745, max: 8334, goal: 5540 },
  '-7':   { min: 1117, max: 8697, goal: 4907 },
  '-6':   { min: 1712, max: 7861, goal: 4787 },
  '-5':   { min: 1265, max: 7916, goal: 4591 },
  '-4':   { min: 1369, max: 8900, goal: 5135 },
  '-3':   { min: 1073, max: 7770, goal: 4422 },
  '-2':   { min: 1327, max: 8164, goal: 4746 },
  '-1':   { min: 164, max: 6648, goal: 3407 },
  '0':    { min: 0, max: 1738, goal: 806 },
  '1':    { min: 0, max: 2240, goal: 1040 },
  '2':    { min: 0, max: 2026, goal: 860 },
  '3':    { min: 0, max: 2433, goal: 1072 },
  '4':    { min: 0, max: 2802, goal: 1340 },
  '5':    { min: 30, max: 2965, goal: 1498 },
  '6':    { min: 88, max: 3227, goal: 1658 },
  '7':    { min: 151, max: 3515, goal: 1834 },
  '8':    { min: 259, max: 3842, goal: 2051 },
  '9':    { min: 288, max: 4056, goal: 2172 },
  '10':   { min: 392, max: 4226, goal: 2310 },
  '11':   { min: 577, max: 4369, goal: 2474 },
  '12':   { min: 634, max: 4403, goal: 2519 },
  '13':   { min: 593, max: 4804, goal: 2699 },
  '14':   { min: 781, max: 5013, goal: 2897 },
  '15':   { min: 738, max: 5229, goal: 2984 },
  '16':   { min: 872, max: 5324, goal: 3099 },
  '17':   { min: 887, max: 5715, goal: 3301 },
  '18':   { min: 893, max: 5737, goal: 3316 },
  '19':   { min: 1089, max: 6025, goal: 3557 },
  '20':   { min: 1064, max: 6166, goal: 3615 },
  '21':   { min: 975, max: 6185, goal: 3581 },
  '22':   { min: 1295, max: 6206, goal: 3751 },
  '23':   { min: 1348, max: 6474, goal: 3912 },
  '24':   { min: 1228, max: 6471, goal: 3850 },
  '25':   { min: 1126, max: 6580, goal: 3853 },
  '26':   { min: 1180, max: 6588, goal: 3885 },
  '27':   { min: 1421, max: 6786, goal: 4104 },
  '28':   { min: 1519, max: 6687, goal: 4103 },
  '29':   { min: 1621, max: 6999, goal: 4310 },
  '30':   { min: 1404, max: 7000, goal: 4203 },
  '31':   { min: 1556, max: 7329, goal: 4443 },
  '32':   { min: 1612, max: 7419, goal: 4516 },
  '33':   { min: 1677, max: 7307, goal: 4492 },
  '34':   { min: 1645, max: 7244, goal: 4445 },
  '35':   { min: 1734, max: 7484, goal: 4609 },
  '36':   { min: 1891, max: 7406, goal: 4649 },
  '37':   { min: 1982, max: 7102, goal: 4542 },
  '38':   { min: 1767, max: 7349, goal: 4559 },
  '39':   { min: 2021, max: 7170, goal: 4596 },
  '40':   { min: 1827, max: 7522, goal: 4675 },
  '41':   { min: 1606, max: 7377, goal: 4492 },
  '42':   { min: 1662, max: 7789, goal: 4726 },
  '43':   { min: 1461, max: 7636, goal: 4549 },
  '44':   { min: 2221, max: 8044, goal: 5133 },
  '45':   { min: 1884, max: 7999, goal: 4942 },
  '46':   { min: 2202, max: 8364, goal: 5283 },
  '47':   { min: 2007, max: 7911, goal: 4959 },
  '48':   { min: 2162, max: 8313, goal: 5238 },
  '49':   { min: 2157, max: 8368, goal: 5263 },
  '50':   { min: 2364, max: 8369, goal: 5367 },
  '51':   { min: 2161, max: 8032, goal: 5097 },
  '52':   { min: 2183, max: 8266, goal: 5225 },
  '53':   { min: 2548, max: 8364, goal: 5456 },
  '54':   { min: 2290, max: 8276, goal: 5283 },
  '55':   { min: 2492, max: 8172, goal: 5333 },
  '56':   { min: 2597, max: 8377, goal: 5487 },
  '57':   { min: 2478, max: 8748, goal: 5614 },
  '58':   { min: 2117, max: 8586, goal: 5352 },
  '59':   { min: 2518, max: 8389, goal: 5454 },
  '60':   { min: 2456, max: 9189, goal: 5823 },
}

export const STEP_RANGE_MIN_DAY = -10
export const STEP_RANGE_MAX_DAY = 60

// Clamp an arbitrary day offset into the table's covered range.
export function clampStepDay(day) {
  if (day < STEP_RANGE_MIN_DAY) return STEP_RANGE_MIN_DAY
  if (day > STEP_RANGE_MAX_DAY) return STEP_RANGE_MAX_DAY
  return day
}

// { min, max } range for a whole-day offset from surgery, or null if out of any
// sensible bound (offset is always clamped, so this only returns null on a
// missing table entry which should never happen).
export function stepRangeForDayOffset(dayOffset) {
  if (dayOffset === null || dayOffset === undefined || Number.isNaN(dayOffset)) return null
  const r = STEP_RANGE_BY_DAY[String(clampStepDay(dayOffset))]
  return r || null
}
